module.exports = __webpack_public_path__ + "img/productpage_icon_line.b5e74f0d.png";